export interface PartsRating {
  part_id: string;
  part_name: string;
  severity: Severity;
  final_severity?: string | number;
  labour_cost: string | number;
  part_cost: string | number;
  repair_cost: string | number;
  rating_id?: string;
}

export interface SeveritySelected {
  exterior: {
    state: SeveritySelectedCurrent[];
    overall: {
      rating: string | number;
      labour_cost: string | number;
      part_cost: string | number;
      repair_cost: string | number;
    };
    endCorrection?: object;
  };
  interior: {
    state: SeveritySelectedCurrent[];
    overall: {
      rating: string | number;
      labour_cost: string | number;
      part_cost: string | number;
      repair_cost: string | number;
    };
    endCorrection?: {
      air_bag?: SeveritySelectedCurrent;
    };
  };
  mechanics: {
    state: SeveritySelectedCurrent[];
    overall: {
      rating: string | number;
      labour_cost: string | number;
      part_cost: string | number;
      repair_cost: string | number;
    };
    endCorrection?: {
      engine?: SeveritySelectedCurrent;
      transmission?: SeveritySelectedCurrent;
    };
  };
  frame: {
    state: SeveritySelectedCurrent[];
    overall: {
      rating: string | number;
      labour_cost: string | number;
      part_cost: string | number;
      repair_cost: string | number;
    };
    endCorrection?: {
      floor_pans?: SeveritySelectedCurrent;
      lft_a_pillar?: SeveritySelectedCurrent;
      lft_apron?: SeveritySelectedCurrent;
      lft_b_pillar?: SeveritySelectedCurrent;
      lft_c_pillar?: SeveritySelectedCurrent;
      lft_frt_rail?: SeveritySelectedCurrent;
      lft_rr_d_pillar?: SeveritySelectedCurrent;
      lft_rr_lock_pillar?: SeveritySelectedCurrent;
      lft_rr_rail?: SeveritySelectedCurrent;
      lft_strut_tower_apron?: SeveritySelectedCurrent;
      rft_a_pillar?: SeveritySelectedCurrent;
      rft_apron?: SeveritySelectedCurrent;
      rft_b_pillar?: SeveritySelectedCurrent;
      rft_c_pillar?: SeveritySelectedCurrent;
      rht_frt_rail?: SeveritySelectedCurrent;
      rht_rr_d_pillar?: SeveritySelectedCurrent;
      rht_rr_lock_pillar?: SeveritySelectedCurrent;
      rht_rr_rail?: SeveritySelectedCurrent;
    };
  };
  major_options: {
    state: SeveritySelectedCurrent[];
    overall: {
      rating: string | number;
      labour_cost: string | number;
      part_cost: string | number;
      repair_cost: string | number;
    };
    endCorrection?: object;
  };
}

export interface EndCorrectionFactors {
  factor: string;
  selectedCondition: object[];
  value: string | number;
}

export interface SeveritySelectedCurrent {
  severity: string | number;
  severity_level: number;
  part_id: string;
  labour_cost: string | number;
  part_cost: string | number;
  repair_cost: number;
  selected_condition?: object[];
}

export interface Severity {
  1: string | number;
  2: string | number;
  3: string | number;
  4: string | number;
  5: string | number;
}
